import { validate } from '@krugom/validator';
import { isPlainObject } from 'lodash';
import store from '../../../store';
import { ApiRequest } from '../../../store/saga/api/actions';

const requestTo = (arg?: any) => {
  const scheme = {
    type: 'object',
    properties: {
      path: {
        type: 'string',
        required: true,
      },
      method: {
        type: 'string',
        required: false,
        pattern: /^(GET|POST|PUT|DELETE)$/,
      },
      query: {
        type: 'custom',
        validator: (v: any) => isPlainObject(v),
      },
      body: {
        type: 'custom',
        validator: (v: any) => isPlainObject(v),
      },
      headers: {
        type: 'custom',
        validator: (v: any) => isPlainObject(v),
      },
      force: {
        type: 'boolean',
      },
      key: {
        type: 'string',
      },
      type: {
        type: 'string',
      },
    },
  };
  const result = validate(arg, scheme);
  if (!result.isValid) return;
  store.dispatch(ApiRequest(arg));
};

export default requestTo;
